export default __webpack_public_path__ + "static/media/icon_envelope.5454e973.svg";